import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';

import { Category } from '@fcom/dapi/api/models/category';
import { FinnairBoundItem } from '@fcom/dapi/api/models/finnair-bound-item';
import { FinnairPassengerItem } from '@fcom/dapi/api/models/finnair-passenger-item';
import { FinnairServiceItemWithUpsell } from '@fcom/dapi/interfaces/services.interface';

import { getSummaryForCategory } from '../../../../utils/services-summary.utils';

interface ServiceSummary {
  quantity?: number;
  description: string;
  text?: string;
}

@Component({
  selector: 'fin-included-product-item-summary',
  templateUrl: './included-product-item-summary.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IncludedProductItemSummaryComponent implements OnInit, OnChanges {
  @Input() passengers: FinnairPassengerItem[];
  @Input() bound: FinnairBoundItem;
  @Input() service: FinnairServiceItemWithUpsell;
  @Input() isShortHaulFlight: boolean;
  @Input() bodyClass = 'font-body-2 font-body-small';
  @Input() showPendingServicesInTitles = false;
  protected readonly Category = Category;
  protected serviceSummary: ServiceSummary[] = [];

  ngOnChanges(): void {
    this.update();
  }

  ngOnInit(): void {
    this.update();
  }

  private update() {
    this.serviceSummary = getSummaryForCategory(
      this.service?.category,
      this.bound,
      this.service,
      this.isShortHaulFlight,
      this.showPendingServicesInTitles
    );
  }
}
